/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TutorialsIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Tutorials',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M5.51562,14.18457c-.07129,0-.14355-.00977-.21582-.03223l-2.67773-.80566c-.95117-.27051-1.62207-1.16016-1.62207-2.15918V3.25098c0-.71191.32617-1.36719.89453-1.7959.56934-.42969,1.28613-.56348,1.97363-.36816l5.13184,1.4668,5.13184-1.46582c.68457-.19824,1.4043-.0625,1.97363.36719.56836.42871.89453,1.08398.89453,1.7959v2.85449c0,.41406-.33594.75-.75.75s-.75-.33594-.75-.75v-2.85449c0-.2373-.1084-.45605-.29785-.59863-.19043-.14355-.43262-.18945-.6582-.12207l-5.33789,1.52441c-.13477.03906-.27734.03906-.41211,0l-5.33789-1.52539c-.22559-.06543-.46777-.02051-.6582.12305-.18945.14258-.29785.36133-.29785.59863v7.93652c0,.33301.22363.62891.54395.71973l2.6875.80957c.39648.11914.62207.53711.50195.93359-.09766.3252-.39551.53418-.71777.53418Z"
      fill="currentColor"
    />
    <path
      d="M6.71777,6.74316c-.06836,0-.1377-.00879-.20605-.0293l-2.01172-.5752c-.39844-.11328-.62891-.52832-.51465-.92676.11328-.39844.52832-.63379.92676-.51465l2.01172.5752c.39844.11328.62891.52832.51465.92676-.09375.3291-.39355.54395-.7207.54395Z"
      fill="currentColor"
    />
    <path
      d="M6.71777,10.05566c-.06836,0-.1377-.00879-.20605-.0293l-2.01172-.5752c-.39844-.11328-.62891-.52832-.51465-.92676.11328-.39844.52832-.63574.92676-.51465l2.01172.5752c.39844.11328.62891.52832.51465.92676-.09375.3291-.39355.54395-.7207.54395Z"
      fill="currentColor"
    />
    <path
      d="M11.28223,6.74316c-.32715,0-.62695-.21484-.7207-.54395-.11426-.39844.11621-.81348.51465-.92676l2.01172-.5752c.39746-.11719.81348.11719.92676.51465.11426.39844-.11621.81348-.51465.92676l-2.01172.5752c-.06836.02051-.1377.0293-.20605.0293Z"
      fill="currentColor"
    />
    <path
      d="M13.5,19c-3.03223,0-5.5-2.46777-5.5-5.5s2.46777-5.5,5.5-5.5,5.5,2.46777,5.5,5.5-2.46777,5.5-5.5,5.5ZM13.5,9.5c-2.20605,0-4,1.79395-4,4s1.79395,4,4,4,4-1.79395,4-4-1.79395-4-4-4Z"
      fill="currentColor"
    />
    <path
      d="M12,14.95334v-2.90669c0-.42868.414-.69002.73316-.46282l2.35068,1.45334c.30029.21377.30029.71188,0,.92565l-2.35068,1.45334c-.31916.2272-.73316-.03415-.73316-.46282Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
